module.exports = __webpack_public_path__ + "img/b1.ad6c0274.jpg";